module.exports = __webpack_public_path__ + "img/raffle-drum.e0cebea0.jpg";